document.addEventListener("DOMContentLoaded", () => {
  const crossBtn = document.querySelector(".cross-btn-custom");
  const closeBtn = document.querySelector(".header__menu-icon .icon-button-header-menu-close");

  if (!crossBtn || !closeBtn) return;

  crossBtn.addEventListener("click", (e) => {
    // optional: agar aap chahen ke default action na ho
    // e.preventDefault();

    closeBtn.click();
  });
});



document.addEventListener('click', function (e) {
  if (e.target.closest('.search-bar-ps')) {
    const menuIcon = document.querySelector('.header__icon-menu');
    if (menuIcon) menuIcon.click();
  }
});